import { createApp } from 'vue'
import Basket from './Basket'

const el = '.kb-component--basket'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((BasketDOM) => {
            const asideResults = BasketDOM.dataset.asideResults
                ? JSON.parse(BasketDOM.dataset.asideResults)
                : {}
            const component = createApp(Basket, { asideResults }).use(Store)
            component.mount(BasketDOM)
        })
    }
}
